<template>
  <div>
    <slot :requestDownload="requestDownload" />
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';
  import date from '@/mixins/date';

  export default {
    props: ['response'],

    mixins: [date],

    computed: {
      ...mapState([
        'primaryColour',
      ]),

      ...mapGetters('admin', [
        'activeSurvey',
      ]),

      downloadExtension() {
        return this.activeSurvey.has_file_fields ? 'zip' : 'xlsx';
      },

      downloadName() {
        if (this.response) {
          // eslint-disable-next-line max-len
          return `${this.activeSurvey.title} Single Response Export - ${this.formatDateShort(this.response.updated_at, true)}.${this.downloadExtension}`;
        }

        return `${this.activeSurvey.title} Full Export - ${this.currentDate}.${this.downloadExtension}`;
      },

      apiDownloadUrl() {
        let url = `admin/surveys/${this.activeSurvey.id}/responses`;
        url += this.response ? `/${this.response.id}.${this.downloadExtension}` : `.${this.downloadExtension}`;
        return url;
      },
    },

    methods: {
      ...mapActions([
        'setMessage',
      ]),

      requestDownload() {
        this.$parent.$emit('start-loading');
        return this.$http.get(this.apiDownloadUrl, { responseType: 'blob' })
          .then((response) => {
            const blob = response.data;
            if (navigator.msSaveBlob) {
              navigator.msSaveBlob(blob, this.downloadName);
            } else {
              const a = document.createElement('a');
              a.href = URL.createObjectURL(blob);
              a.download = this.downloadName;
              document.body.appendChild(a);
              a.click();
              a.remove();
            }
            this.$parent.$emit('stop-loading');
          })
          .catch(() => {
            this.$parent.$emit('stop-loading');
            this.setMessage({
              text: 'Could not export survey responses',
              messageType: 'error',
            });
          });
      },
    },
  };
</script>
